import * as yup from "yup";

export const vehicleTypeSchema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required("Vehicle Type Name is required")
      .min(1, "Vehicle Type Name cannot be blank")
      .matches(/^[a-zA-Z0-9 ]+$/, "Only alphabets, numbers and spaces are allowed"),
    cost: yup.string().required("Vehicle Type Cost is required"),
    weightLimit: yup.string().required("Weight Capacity is required"),
    status: yup.string().required("Vehicle Type Status is required"),
    helperCount: yup.number().typeError("Must be a number").nullable(),
    isHelperRequired: yup.boolean().nullable(),
    // waitingDuration: yup.string().required("Waiting Duration is required"),
    // waitingPrice: yup.string().required("Waiting Price is required"),
  })
  .required();

export const settingSchema = yup
  .object({
    adminCommission: yup.string().required("Admin Commission is required"),
    baseFare: yup.string().required("Base Fare Cost is required"),
    kmCost: yup.string().required("Km Cost is required"),
    fragileCost: yup.string().required("Fragile Item Cost is required"),
  })
  .required();

export const categorySchema = yup
  .object({
    categoryName: yup.string().required("Category Name is required"),
    description: yup.string().required("Description is required"),
    status: yup.string().required("Status is required"),
    estBaseWeight: yup.string().required("Est. Base Weight is required"),
    isFragile: yup.boolean(),
    isHeavy: yup.boolean(),
  })
  .required();
export const promoSchema = yup
  .object({
    promoCode: yup.string().required("Promo Code is required"),
    discountType: yup.string().required("Discount Type is required"),
    discountValue: yup.number().typeError("Discount Value must be a number").required("Discount Value is required"),
    startDate: yup.string().required("Start Date is required"),
    expiryDate: yup
      .string()
      .required("Expiry Date is required")
      .test(
        "is-on-or-after-start",
        "Expiry date must be the same day or after the start date",
        function (expiryDate) {
          const { startDate } = this.parent;
          if (!startDate || !expiryDate) return true;
          return expiryDate >= startDate;
        }
      ),
    usageLimit: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
        return value;
      })
      .nullable()
      .min(1, "Enter at least 1, or leave empty for unlimited"),
    usageLimitPerUser: yup
      .number()
      .transform((value, originalValue) => {
        if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
        return value;
      })
      .nullable()
      .min(0, "Enter 0 for unlimited, or a positive number"),
    minOrderValue: yup.number().typeError("Value must be a number").transform((value) => (isNaN(value) ? undefined : value)).nullable(),
    maxDiscountCap: yup.number().typeError("Value must be a number").transform((value) => (isNaN(value) ? undefined : value)).nullable(),
    firstOrderOnly: yup.boolean(),
    users: yup.array().of(yup.string()),
    status: yup.string().required("Status is required"),
  })
  .required();

export const notificationSchema = yup
  .object({
    title: yup.string().required("Title is required"),
    body: yup.string().required("Message body is required"),
    target: yup.string().oneOf(["all", "user", "mover"], "Please select a valid target segment").required("Target segment is required"),
  })
  .required();
